/*
 * @Author: wang.zhiqin wang.zhiqin@trs.com.cn
 * @Date: 2023-06-26 12:42:04
 * @LastEditors: sunyan 1055697528@qq.com
 * @LastEditTime: 2024-04-16 10:50:33
 * @FilePath: \jsczt_vue\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Homem from '@/views/moblie/index.vue'
import list from '@/views/moblie/list.vue'
import moblieList from '@/views/moblie/moblieList.vue'
import detail from '@/views/moblie/detail.vue'
import overView from '@/views/overview.vue'
import overView2 from '@/views/overview2.vue'
import overViews from '@/views/overviews.vue'
import overViewt from '@/views/overviewt.vue'
import detailsPage from '@/views/detailsPage.vue'
import Indexs from '@/views/indexs.vue'
Vue.use(Router)
const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: window.innerWidth < 769 ? Homem : Home
      // component:  Homem 
    },
    {
      path: '/Indexs',
      name: 'Indexs',
      component: Indexs
    },
    {
      path: '/Homem',
      name: 'Homem',
      component: Homem
    },
    {
      path: '/list',
      name: 'list',
      component: list
    },
    {
      path: '/moblieList',
      name: 'moblieList',
      component: moblieList
    },
    {
      path: '/detail',
      name: 'detail',
      component: detail
    },
    {
      path: '/overView',
      name: 'overView',
      component: overView
    },
    {
      path: '/overViews',
      name: 'overViews',
      component: overViews
    },
    {
      path: '/overView2',
      name: 'overView2',
      component: overView2
    },
    {
      path: '/overViewt',
      name: 'overViewt',
      component: overViewt
    },
    {
      path: '/detailsPage',
      name: 'detailsPage',
      component: detailsPage
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js